// extracted by mini-css-extract-plugin
export default {"button":"innerButton_button__KPvEW","reverse":"innerButton_reverse__DtyHN","disabled":"innerButton_disabled__EsBaf"};